import { KYMW2800Component } from './kymw2800.component';

/**
 * 週別部門別供給高GP予算進捗画面の値を管理するクラス
 *
 * @export KYMW2800Model
 * @class KYMW2800Model
 */
export class KYMW2800Model {

  kymw2800Component: KYMW2800Component;

    /** 開始 受注コード */
    public orderCodeFrom: string = <string>'';
    /** 終了 受注コード */
    public orderCodeTo: string = <string>'';

}
